import { Field } from "formik";
import IconCheckCircle from "./icons/IconCheckCircle";
import IconCheckCircleChecked from "./icons/IconCheckCircleChecked";

export default function RadioCard(props: {
  children?: React.ReactNode;
  id: string;
  name: string;
  text: React.ReactNode;
  value?: string;
  checkIconTop?: string;
}) {
  const { children, id, value, name, text, checkIconTop } = props;
  return (
    <>
      <Field
        type="radio"
        className="btn-check"
        name={name}
        id={id}
        autoComplete="off"
        value={value ? value : text}
      />
      <div className="c-radio-card">
        <label className="c-radio-card__label" htmlFor={id}>
          <span
            className="check-icon d-flex align-items-center"
            style={{ marginTop: checkIconTop ? checkIconTop : "0" }}
          >
            <IconCheckCircleChecked className="text-primary" />
            <IconCheckCircle className="text-border" />
          </span>
          <span className="flex-grow-1">{text}</span>
        </label>
        {children ? (
          <div className="c-radio-card__content">
            <div className="c-radio-card__content-inner">
              <div className="position-relative mb-2">{children}</div>
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
    </>
  );
}
